
import { WeatherCondition } from '@/types/weather';

export const getRandomTemperature = (condition: WeatherCondition): number => {
  switch (condition) {
    case 'clear':
      return Math.floor(Math.random() * 10) + 25;
    case 'partlyCloudy':
      return Math.floor(Math.random() * 8) + 20;
    case 'cloudy':
      return Math.floor(Math.random() * 6) + 18;
    case 'rain':
      return Math.floor(Math.random() * 5) + 15;
    case 'heavyRain':
      return Math.floor(Math.random() * 5) + 12;
    case 'thunderstorm':
      return Math.floor(Math.random() * 5) + 10;
    case 'snow':
      return Math.floor(Math.random() * 5) - 5;
    case 'fog':
      return Math.floor(Math.random() * 6) + 8;
    case 'wind':
      return Math.floor(Math.random() * 8) + 12;
    case 'alert':
      return Math.floor(Math.random() * 15) + 15;
    default:
      return Math.floor(Math.random() * 10) + 15;
  }
};

export const getRandomHumidity = (condition: WeatherCondition): number => {
  switch (condition) {
    case 'clear':
      return Math.floor(Math.random() * 20) + 30;
    case 'partlyCloudy':
      return Math.floor(Math.random() * 20) + 40;
    case 'cloudy':
      return Math.floor(Math.random() * 20) + 50;
    case 'rain':
      return Math.floor(Math.random() * 15) + 70;
    case 'heavyRain':
      return Math.floor(Math.random() * 10) + 80;
    case 'thunderstorm':
      return Math.floor(Math.random() * 10) + 85;
    case 'snow':
      return Math.floor(Math.random() * 20) + 70;
    case 'fog':
      return Math.floor(Math.random() * 10) + 90;
    default:
      return Math.floor(Math.random() * 30) + 50;
  }
};

export const getRandomWindSpeed = (condition: WeatherCondition): number => {
  switch (condition) {
    case 'clear':
      return Math.floor(Math.random() * 10) + 5;
    case 'partlyCloudy':
      return Math.floor(Math.random() * 15) + 5;
    case 'cloudy':
      return Math.floor(Math.random() * 20) + 10;
    case 'rain':
      return Math.floor(Math.random() * 25) + 15;
    case 'heavyRain':
      return Math.floor(Math.random() * 30) + 25;
    case 'thunderstorm':
      return Math.floor(Math.random() * 40) + 30;
    case 'wind':
      return Math.floor(Math.random() * 50) + 45;
    default:
      return Math.floor(Math.random() * 20) + 10;
  }
};

export const getWeatherLabel = (condition: WeatherCondition): string => {
  switch (condition) {
    case 'clear': return 'Clear';
    case 'partlyCloudy': return 'Partly Cloudy';
    case 'cloudy': return 'Cloudy';
    case 'rain': return 'Rain';
    case 'heavyRain': return 'Heavy Rain';
    case 'thunderstorm': return 'Thunderstorm';
    case 'snow': return 'Snow';
    case 'fog': return 'Fog';
    case 'wind': return 'Wind';
    case 'alert': return 'Weather Alert';
    default: return 'Cloudy';
  }
};
